/* eslint-disable no-unused-vars */
import React from 'react';
import Rollbar from 'rollbar';
import DationUserComponent from './DationUserComponent';

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			rollbar: new Rollbar({
				accessToken: process.env.ROLLBAR_ACCESS_TOKEN,
				captureUncaught: true,
				captureUnhandledRejections: true,
				payload: {
					person: this.constructPerson(),
					client: {
						javascript: {
							code_version: process.env.REACT_APP_VERSION,
							guess_uncaught_frames: true,
						},
					},
				},
			}),
		};
	}

	componentDidUpdate() {
		const { rollbar } = this.state;
		rollbar.configure({
			payload: {
				person: this.constructPerson(),
			},
		});
	}

	componentDidCatch(error) {
		const { rollbar } = this.state;
		rollbar.error(error);
	}

	constructPerson = () => {
		const { profile } = this.props;
		if (profile === null) {
			return {
				id: null,
			};
		}

		let person = {
			id: profile.id,
		};

		const { companyContactPerson } = profile;

		if (undefined !== companyContactPerson) {
			person = {
				...person,
				email: companyContactPerson.emailAddress,
			};
		}

		return person;
	};

	render() {
		const { children } = this.props;
		return children;
	}
}

export default DationUserComponent(ErrorBoundary);
